import { proxy } from "@/util/proxy.mjs";

interface UserInfoRefs {
  ImageContainer: React.FC;
  UserTag: React.FC;
}

export const userInfoRefs = proxy<UserInfoRefs>({
  ImageContainer: null,
  UserTag: null,
});
